module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX 发布日志")]), _vm._v(" "), _c('h2', [_vm._v("next (未发布)")]), _vm._v(" "), _c('h3', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加属性 type")])])]), _vm._v(" "), _c('h3', [_vm._v("Swipeout")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  添加属性 disabled")])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.10.1.html"
    }
  }, [_vm._v("v2.10.1")])]), _vm._v(" "), _c('h3', [_vm._v("XTextarea")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复回车符导致的字符计算错误 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/3784",
      "target": "_blank"
    }
  }, [_vm._v("#3784")])])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.9.4.html"
    }
  }, [_vm._v("v2.9.4")])]), _vm._v(" "), _c('h3', [_vm._v("Picker")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  修复多级联动模式下，快速滚动多个项，取值不正确")])])]), _vm._v(" "), _c('h3', [_vm._v("Tab")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-change"
  }, [_vm._v("change")]), _vm._v("  修复 tab的父级width没有100%或者有padding 滚动造成文字跟横杠错位问题 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2850",
      "target": "_blank"
    }
  }, [_vm._v("#2850")])])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/2.9.3.html"
    }
  }, [_vm._v("2.9.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.9.2.html"
    }
  }, [_vm._v("v2.9.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.9.1.html"
    }
  }, [_vm._v("v2.9.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.9.0.html"
    }
  }, [_vm._v("v2.9.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.8.1.html"
    }
  }, [_vm._v("v2.8.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.8.0.html"
    }
  }, [_vm._v("v2.8.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.7.9.html"
    }
  }, [_vm._v("v2.7.9")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.7.8.html"
    }
  }, [_vm._v("v2.7.8")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.7.7.html"
    }
  }, [_vm._v("v2.7.7")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/2.7.6.html"
    }
  }, [_vm._v("2.7.6")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.7.6.html"
    }
  }, [_vm._v("v2.7.6")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.7.5.html"
    }
  }, [_vm._v("v2.7.5")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.7.4.html"
    }
  }, [_vm._v("v2.7.4")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.7.3.html"
    }
  }, [_vm._v("v2.7.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.7.2.html"
    }
  }, [_vm._v("v2.7.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.7.1.html"
    }
  }, [_vm._v("v2.7.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.7.0.html"
    }
  }, [_vm._v("v2.7.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.6.5.html"
    }
  }, [_vm._v("v2.6.5")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.6.4.html"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.6.3.html"
    }
  }, [_vm._v("v2.6.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.6.2.html"
    }
  }, [_vm._v("v2.6.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.6.1.html"
    }
  }, [_vm._v("v2.6.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.6.0.html"
    }
  }, [_vm._v("v2.6.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.12.html"
    }
  }, [_vm._v("v2.5.12")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.11.html"
    }
  }, [_vm._v("v2.5.11")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.10.html"
    }
  }, [_vm._v("v2.5.10")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.9.html"
    }
  }, [_vm._v("v2.5.9")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.8.html"
    }
  }, [_vm._v("v2.5.8")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.7.html"
    }
  }, [_vm._v("v2.5.7")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.6.html"
    }
  }, [_vm._v("v2.5.6")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.5.html"
    }
  }, [_vm._v("v2.5.5")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.4.html"
    }
  }, [_vm._v("v2.5.4")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.3.html"
    }
  }, [_vm._v("v2.5.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.2.html"
    }
  }, [_vm._v("v2.5.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.1.html"
    }
  }, [_vm._v("v2.5.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.5.0.html"
    }
  }, [_vm._v("v2.5.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.4.1.html"
    }
  }, [_vm._v("v2.4.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.4.0.html"
    }
  }, [_vm._v("v2.4.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.3.8.html"
    }
  }, [_vm._v("v2.3.8")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.3.7.html"
    }
  }, [_vm._v("v2.3.7")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.3.6.html"
    }
  }, [_vm._v("v2.3.6")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.3.5.html"
    }
  }, [_vm._v("v2.3.5")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.3.4.html"
    }
  }, [_vm._v("v2.3.4")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.3.3.html"
    }
  }, [_vm._v("v2.3.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.3.2.html"
    }
  }, [_vm._v("v2.3.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.3.1.html"
    }
  }, [_vm._v("v2.3.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.2.2.html"
    }
  }, [_vm._v("v2.2.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.2.1.html"
    }
  }, [_vm._v("v2.2.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.2.1-rc.8.html"
    }
  }, [_vm._v("v2.2.1-rc.8")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.2.1-rc.7.html"
    }
  }, [_vm._v("v2.2.1-rc.7")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.2.1-rc.6.html"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.2.1-rc.4.html"
    }
  }, [_vm._v("v2.2.1-rc.4")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.2.1-rc.3.html"
    }
  }, [_vm._v("v2.2.1-rc.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.2.1-rc.2.html"
    }
  }, [_vm._v("v2.2.1-rc.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.2.1-rc.1.html"
    }
  }, [_vm._v("v2.2.1-rc.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.2.0.html"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.14.html"
    }
  }, [_vm._v("v2.1.1-rc.14")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.13.html"
    }
  }, [_vm._v("v2.1.1-rc.13")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.12.html"
    }
  }, [_vm._v("v2.1.1-rc.12")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.11.html"
    }
  }, [_vm._v("v2.1.1-rc.11")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.10.html"
    }
  }, [_vm._v("v2.1.1-rc.10")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.9.html"
    }
  }, [_vm._v("v2.1.1-rc.9")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.8.html"
    }
  }, [_vm._v("v2.1.1-rc.8")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.7.html"
    }
  }, [_vm._v("v2.1.1-rc.7")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.6.html"
    }
  }, [_vm._v("v2.1.1-rc.6")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.5.html"
    }
  }, [_vm._v("v2.1.1-rc.5")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.4.html"
    }
  }, [_vm._v("v2.1.1-rc.4")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.3.html"
    }
  }, [_vm._v("v2.1.1-rc.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.2.html"
    }
  }, [_vm._v("v2.1.1-rc.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.1-rc.1.html"
    }
  }, [_vm._v("v2.1.1-rc.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.0.html"
    }
  }, [_vm._v("v2.1.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.0-rc.51.html"
    }
  }, [_vm._v("v2.1.0-rc.51")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.0-rc.50.html"
    }
  }, [_vm._v("v2.1.0-rc.50")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.0-rc.49.html"
    }
  }, [_vm._v("v2.1.0-rc.49")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.0-rc.48.html"
    }
  }, [_vm._v("v2.1.0-rc.48")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.0-rc.47.html"
    }
  }, [_vm._v("v2.1.0-rc.47")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.1.0-rc.46.html"
    }
  }, [_vm._v("v2.1.0-rc.46")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.0.14.html"
    }
  }, [_vm._v("v2.0.14")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.0.1.html"
    }
  }, [_vm._v("v2.0.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/changelog/v2.0.0.html"
    }
  }, [_vm._v("v2.0.0")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-32a881f9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-32a881f9"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/changelog-192.vue
// module id = 2129
// module chunks = 459